import preloadedCards from "../preloadedCards";
import ArrayUtils from "../util/array";
export var cardLookup = ArrayUtils.mapObject(preloadedCards, function (c) { return [c.value, c]; });
var suitToUnicode = {
    clubs: "♧",
    diamonds: "♢",
    hearts: "♡",
    spades: "♤",
};
var suitToFilledUnicode = {
    clubs: "♣",
    diamonds: "♦",
    hearts: "♥",
    spades: "♠",
};
var cardInfoToSuit = function (cardInfo) {
    switch (cardInfo.typ) {
        case "♢":
            return "diamonds";
        case "♧":
            return "clubs";
        case "♡":
            return "hearts";
        case "♤":
            return "spades";
        default:
            throw new Error("Invalid cardInfo");
    }
};
export var unicodeToCard = function (unicode) {
    if (unicode === "🂠") {
        return { type: "unknown" };
    }
    if (!(unicode in cardLookup)) {
        throw new Error("Invalid card string: ".concat(unicode));
    }
    var cardInfo = cardLookup[unicode];
    if (unicode === "🃟") {
        return { type: "little_joker" };
    }
    else if (unicode === "🃏") {
        return { type: "big_joker" };
    }
    else {
        return {
            rank: cardInfo.number,
            suit: cardInfoToSuit(cardInfo),
            type: "suit_card",
        };
    }
};
/**
 * Non-throwing counterpart of `unicodeToCard`, returning `null` for anything it
 * cannot parse.
 *
 * Prefer this ANYWHERE the result is used during render. Card glyphs arrive from
 * the server, and `unicodeToCard` throws on an unrecognised one; a throw during
 * render escapes to the error boundary and blanks the entire game UI for that
 * client. Degrading one card to a face-down placeholder is always the better
 * failure mode.
 */
export var tryUnicodeToCard = function (unicode) {
    try {
        return unicodeToCard(unicode);
    }
    catch (_a) {
        return null;
    }
};
export var cardToUnicodeSuit = function (card, fill) {
    if (fill === void 0) { fill = true; }
    var table = fill ? suitToFilledUnicode : suitToUnicode;
    return table[card.suit];
};
var suitToName = {
    clubs: "clubs",
    diamonds: "diamonds",
    hearts: "hearts",
    spades: "spades",
};
// Human-readable accessible label for a card glyph (used as aria-label).
//
// When `state` is supplied (computed from the live Trump), the label also
// announces whether the card is currently trump, the level/rank card, and
// whether it carries points — useful for screen-reader players following the
// game.
export var cardAriaLabel = function (unicode, state) {
    if (unicode === "🂠") {
        return "face-down card";
    }
    if (!(unicode in cardLookup)) {
        return "card";
    }
    var base = "card";
    if (unicode === "🃟") {
        base = "little joker";
    }
    else if (unicode === "🃏") {
        base = "big joker";
    }
    else {
        var card = tryUnicodeToCard(unicode);
        if (card !== null && card.type === "suit_card") {
            base = "".concat(card.rank, " of ").concat(suitToName[card.suit]);
        }
    }
    if (state !== undefined) {
        var tags = [];
        if (state.isTrump)
            tags.push("trump");
        if (state.isLevel)
            tags.push("level card");
        if (state.points !== undefined && state.points > 0) {
            tags.push("".concat(state.points, " points"));
        }
        if (tags.length > 0) {
            base += ", ".concat(tags.join(", "));
        }
    }
    return base;
};
